<ng-template #entityEditTemplate
             let-id="id"
             let-title="title">
  <app-devices-device-edit #modelComponent
                                  (modelChange)="onModelChange($event)"
                                  [creating]="false"
                                  [id]="id"
                                  [loading]="loading$ | async"
                                  [model]="model$ | async"
                                  [readonly]="true"
                                  [stereotyped]="false"
                                  [title]="title">
  </app-devices-device-edit>

  @if (displayPings$ | async) {
    @if ((model$ | async)?.id; as deviceId) {
      <app-devices-device-ping-list [canCreate]="false"
                                           [deviceId]="deviceId"
                                           [getEntityOnModeChange]="false"
                                           [isEmbedded]="true">
      </app-devices-device-ping-list>
    }
  }
</ng-template>

<app-entity-detail [entityDetailBaseComponent]="this"
                          [entityEditTemplate]="entityEditTemplate"
                          [tabCommands]="['.']"
                          [tabHeading]="title | translate"
                          [useTabs]="false"
                          tabId="device">
</app-entity-detail>
